import React from "react";

const NoImportBoard = () => (
  <svg width="171" height="174" viewBox="0 0 171 174" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M85.5 171.711C132.72 171.711 171 133.272 171 85.8553C171 38.4387 132.72 0 85.5 0C38.2797 0 0 38.4387 0 85.8553C0 133.272 38.2797 171.711 85.5 171.711Z"
      fill="#B8AEE9"
      fillOpacity="0.13"
    />
    <rect x="33.3408" y="41.2109" width="103.74" height="132.789" fill="white" />
    <path
      d="M87.7798 109.895C101.002 109.895 111.72 99.1325 111.72 85.8559C111.72 72.5792 101.002 61.8164 87.7798 61.8164C74.5581 61.8164 63.8398 72.5792 63.8398 85.8559C63.8398 99.1325 74.5581 109.895 87.7798 109.895Z"
      fill="#141516"
    />
    <path
      d="M94.5141 88.1094V91.1143C94.5141 91.5128 94.3565 91.8949 94.0759 92.1767C93.7953 92.4585 93.4147 92.6168 93.0179 92.6168H82.5441C82.1473 92.6168 81.7667 92.4585 81.4861 92.1767C81.2055 91.8949 81.0479 91.5128 81.0479 91.1143V88.1094"
      stroke="white"
      strokeWidth="1.80296"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.0402 84.3532L87.7809 88.1094L91.5215 84.3532"
      stroke="white"
      strokeWidth="1.80296"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.7812 88.1094L87.7813 79.0946"
      stroke="white"
      strokeWidth="1.80296"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.6 123.633H72.96C71.0712 123.633 69.54 125.17 69.54 127.067C69.54 128.964 71.0712 130.501 72.96 130.501H102.6C104.489 130.501 106.02 128.964 106.02 127.067C106.02 125.17 104.489 123.633 102.6 123.633Z"
      fill="#E8E4F2"
    />
    <path
      d="M112.86 137.367H62.7003C60.8115 137.367 59.2803 138.905 59.2803 140.801C59.2803 142.698 60.8115 144.236 62.7003 144.236H112.86C114.749 144.236 116.28 142.698 116.28 140.801C116.28 138.905 114.749 137.367 112.86 137.367Z"
      fill="#E8E4F2"
    />
  </svg>
);

export default React.memo(NoImportBoard);
